module.exports = __webpack_public_path__ + "99df67b5b73db2a0c06dcb27f763a6fd.pdf";